import Vue from 'vue'
import numeral from 'numeral'

export default function (app) {
  window.numeral = app.$numeral = numeral
  Vue.use(() => {
    Object.defineProperties(Vue.prototype, {
      $numeral: {
        get () {
          return numeral
        }
      }
    })
  })
}
